import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Block } from 'slate';
import { Editor } from 'slate-react';
import { document } from '../../../helpers/BrowserHelpers';
import classNames from 'classnames';
export var MIN_CELL_WIDTH = 40;
export var DEFAULT_CELL_WIDTH = 200;

var TableCell =
/*#__PURE__*/
function (_Component) {
  _inherits(TableCell, _Component);

  function TableCell(props) {
    var _this;

    _classCallCheck(this, TableCell);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TableCell).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "onSelectionChange", function () {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          selectedCellKeys = _ref.selectedCellKeys,
          _ref$selectedCellsCoo = _ref.selectedCellsCoords,
          selectedCellsCoords = _ref$selectedCellsCoo === void 0 ? [] : _ref$selectedCellsCoo,
          resizingColumn = _ref.resizingColumn,
          resizingColumnWidth = _ref.resizingColumnWidth;

      var _this$props = _this.props,
          editor = _this$props.editor,
          node = _this$props.node;

      var _editor$getCellCoords = editor.getCellCoords(node),
          _editor$getCellCoords2 = _slicedToArray(_editor$getCellCoords, 2),
          columnIndex = _editor$getCellCoords2[1];

      if (selectedCellKeys && selectedCellKeys.includes(node.key)) {
        var selectedColumnIndexes = selectedCellsCoords.reduce(function (memo, _ref2) {
          var _ref3 = _slicedToArray(_ref2, 2),
              columnIndex = _ref3[1];

          if (!memo.includes(columnIndex)) memo.push(columnIndex);
          return memo;
        }, []);
        var minSeletedColumnIndex = Math.min.apply(Math, _toConsumableArray(selectedColumnIndexes));
        var maxSeletedColumnIndex = Math.max.apply(Math, _toConsumableArray(selectedColumnIndexes));

        _this.setState({
          isSelected: true,
          isFirstInSelection: columnIndex === minSeletedColumnIndex,
          isLastInSelection: columnIndex === maxSeletedColumnIndex
        });
      } else if (_this.state.isSelected) {
        _this.setState({
          isSelected: false,
          isFirstInSelection: false,
          isLastInSelection: false
        });
      }

      var isSiblingBeingResized = columnIndex === resizingColumn && !_this.state.isResizing;
      var isSiblingStoppedBeingResized = resizingColumn == null && _this.state.width;

      if (isSiblingBeingResized) {
        _this.setState({
          width: resizingColumnWidth
        });
      } else if (isSiblingStoppedBeingResized && _this.state.width !== null) {
        _this.setState({
          width: null
        });
      } else if (resizingColumn >= 0 && !_this.state.isTableBeingResized) {
        _this.setState({
          isTableBeingResized: true
        });
      } else if (!resizingColumn && _this.state.isTableBeingResized) {
        _this.setState({
          isTableBeingResized: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getCellWidth", function () {
      var realWidth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return Math.max(_this.state.width || _this.props.node.getIn(['data', 'width']) || realWidth && _this.cell && _this.cell.getBoundingClientRect().width || DEFAULT_CELL_WIDTH, MIN_CELL_WIDTH);
    });

    _defineProperty(_assertThisInitialized(_this), "getCellMinWidth", function () {
      return _this.state.width || _this.props.node.getIn(['data', 'width']) || DEFAULT_CELL_WIDTH;
    });

    _defineProperty(_assertThisInitialized(_this), "setEditorCellWidth", function (_ref4) {
      var width = _ref4.width;
      var _this$props2 = _this.props,
          node = _this$props2.node,
          editor = _this$props2.editor;

      var _editor$getCellCoords3 = editor.getCellCoords(node),
          _editor$getCellCoords4 = _slicedToArray(_editor$getCellCoords3, 2),
          columnIndex = _editor$getCellCoords4[1];

      editor.setTableColumnWidth(_this.tableId, columnIndex, width);
    });

    _defineProperty(_assertThisInitialized(_this), "setStoreCellWidth", function (_ref5) {
      var width = _ref5.width;
      var _this$props3 = _this.props,
          node = _this$props3.node,
          editor = _this$props3.editor,
          store = _this$props3.store;

      var _editor$getCellCoords5 = editor.getCellCoords(node),
          _editor$getCellCoords6 = _slicedToArray(_editor$getCellCoords5, 2),
          columnIndex = _editor$getCellCoords6[1];

      store.updateItem(_this.tableId, _objectSpread({}, store.getItem(_this.tableId), {
        resizingColumn: width ? columnIndex : undefined,
        resizingColumnWidth: width
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "setStateCellWidth", function () {
      var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          width = _ref6.width,
          _ref6$isResizing = _ref6.isResizing,
          isResizing = _ref6$isResizing === void 0 ? true : _ref6$isResizing;

      _this.setState({
        isResizing: isResizing,
        width: width
      }, function () {
        _this.setStoreCellWidth({
          width: width
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onResizeMouseDown", function (event) {
      if (event.button !== 0) return;
      if (_this.state.isFullWidth && _this.state.isLastColumn) return;
      event.preventDefault();
      event.stopPropagation();

      if (_this.state.isResizing === false) {
        document.addEventListener('mousemove', _this.onResizeMouseMove);
        document.addEventListener('mouseup', _this.onResizeMouseUp);
      }

      _this.setStateCellWidth({
        width: _this.getCellWidth(true)
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onResizeMouseUp", function () {
      document.removeEventListener('mouseup', _this.onResizeMouseUp);
      document.removeEventListener('mousemove', _this.onResizeMouseMove);

      _this.setEditorCellWidth({
        width: _this.getCellWidth(true)
      });

      _this.setStateCellWidth({
        isResizing: false,
        width: null
      });

      _this.props.editor.setHoveredRow(null);
    });

    _defineProperty(_assertThisInitialized(_this), "onResizeMouseMove", function (_ref7) {
      var movementX = _ref7.movementX;
      var width = _this.getCellWidth(true) + movementX;

      _this.setStateCellWidth({
        width: width
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onResizeDoubleClick", function () {
      _this.setEditorCellWidth({
        width: undefined
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onCellRef", function (cellRef) {
      _this.cell = cellRef;
    });

    _defineProperty(_assertThisInitialized(_this), "onDragStart", function (event) {
      return event.preventDefault();
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseEnter", function (event) {
      if (_this.props.editor.isTableResizing(_this.tableId)) return;
      var _this$props4 = _this.props,
          node = _this$props4.node,
          editor = _this$props4.editor;

      if (event.buttons === 1 && node !== editor.value.anchorBlock) {
        event.preventDefault();
        event.stopPropagation();
        editor.selectTableCellRange({
          end: node
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseDown", function (event) {
      if (_this.props.editor.isTableResizing(_this.tableId)) return;
      if (_this.state.isDraggingFromHere) return;
      var _this$props5 = _this.props,
          editor = _this$props5.editor,
          end = _this$props5.node;
      var start = editor.value.anchorBlock;

      if (event.shiftKey && editor.isValidSelectionRange({
        start: start,
        end: end
      })) {
        event.preventDefault();
        event.stopPropagation();

        _this.props.editor.selectTableCellRange({
          start: start,
          end: end
        });
      } else {
        _this.setState({
          isDraggingFromHere: true
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseUp", function () {
      if (!_this.state.isDraggingFromHere) return;

      _this.setState({
        isDraggingFromHere: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseLeave", function (event) {
      if (_this.props.editor.isTableResizing(_this.tableId)) return;
      if (event.buttons !== 1 || !_this.state.isDraggingFromHere) return;
      var _this$props6 = _this.props,
          node = _this$props6.node,
          editor = _this$props6.editor;
      event.preventDefault();
      event.stopPropagation();
      editor.selectTableCellRange({
        start: node,
        end: node
      });

      _this.setState({
        isDraggingFromHere: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseEnterDragLine", function () {
      if (_this.state.isResizing) return;
      var _this$props7 = _this.props,
          node = _this$props7.node,
          editor = _this$props7.editor;

      var _editor$getCellCoords7 = editor.getCellCoords(node),
          _editor$getCellCoords8 = _slicedToArray(_editor$getCellCoords7, 2),
          columnIndex = _editor$getCellCoords8[1];

      _this.props.editor.setHoveredColumn({
        index: columnIndex
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseLeaveDragLine", function () {
      if (_this.state.isResizing) return;

      _this.props.editor.setHoveredColumn(null);
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseEnterHorizontalDragLine", function () {
      if (_this.state.isResizing) return;
      if (_this.state.isResizing) return;
      var _this$props8 = _this.props,
          node = _this$props8.node,
          editor = _this$props8.editor;

      var _editor$getCellCoords9 = editor.getCellCoords(node),
          _editor$getCellCoords10 = _slicedToArray(_editor$getCellCoords9, 1),
          rowIndex = _editor$getCellCoords10[0];

      _this.props.editor.setHoveredRow({
        index: rowIndex
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseLeaveHorizontalDragLine", function () {
      return !_this.state.isResizing && _this.props.editor.setHoveredRow(null);
    });

    _this.state = {
      isSelected: false,
      isResizing: false,
      isFirstInSelection: false,
      isLastInSelection: false,
      width: null,
      isFullWidth: props.editor.query('isBlockExpanded', props.node),
      isLastColumn: !props.editor.getCellOnTheRight(props.node)
    };
    _this.tableId = props.node.getIn(['data', 'tableId']);
    return _this;
  }

  _createClass(TableCell, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.store.subscribeToItem(this.tableId, this.onSelectionChange);
      this.onSelectionChange(this.props.store.getItem(this.tableId));
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props9 = this.props,
          node = _this$props9.node,
          parent = _this$props9.parent,
          editor = _this$props9.editor;

      var _editor$getCellCoords11 = editor.getCellCoords(node),
          _editor$getCellCoords12 = _slicedToArray(_editor$getCellCoords11, 1),
          rowIndex = _editor$getCellCoords12[0];

      if (prevProps.node.data !== node.data) {
        this.setState({
          isFullWidth: editor.query('isBlockExpanded', node),
          isLastColumn: !editor.getCellOnTheRight(node)
        });
      }

      var prevCountColumn = editor.getTableRowCells(prevProps.parent, rowIndex);
      var countColumn = editor.getTableRowCells(parent, rowIndex);

      if (prevCountColumn.size !== countColumn.size) {
        this.onResizeMouseUp();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.store.unsubscribeFromItem(this.tableId, this.onSelectionChange);
      document.removeEventListener('mousemove', this.onMouseMove);
      document.removeEventListener('mouseup', this.onMouseUp);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props10 = this.props,
          attributes = _this$props10.attributes,
          children = _this$props10.children,
          isFocused = _this$props10.isFocused,
          isMobile = _this$props10.isMobile;
      var _this$state = this.state,
          isFullWidth = _this$state.isFullWidth,
          isLastColumn = _this$state.isLastColumn;
      var cellClassName = classNames('slite-editor-table-cell', {
        focused: isFocused,
        selected: this.state.isSelected,
        'first-in-selection': this.state.isFirstInSelection,
        'last-in-selection': this.state.isLastInSelection
      });
      return React.createElement("td", {
        ref: this.onCellRef,
        className: cellClassName,
        onMouseEnter: this.onMouseEnter,
        onMouseLeave: this.onMouseLeave,
        onMouseUp: this.onMouseUp,
        onMouseDown: this.onMouseDown
      }, React.createElement("div", Object.assign({
        className: "slite-editor-table-cell-content",
        onDragStart: this.onDragStart
      }, attributes), children), !isMobile && !this.props.editor.readOnly && React.createElement(React.Fragment, null, React.createElement("div", {
        className: classNames('slite-editor-table-cell-drag-line vertical', {
          'is-resizing': this.state.width || this.state.isResizing,
          disabled: isFullWidth && isLastColumn
        }),
        onMouseDown: this.onResizeMouseDown,
        onDoubleClick: this.onResizeDoubleClick,
        onMouseEnter: this.onMouseEnterDragLine,
        onMouseLeave: this.onMouseLeaveDragLine,
        contentEditable: false
      }, React.createElement("div", {
        className: "drag-line-background"
      })), React.createElement("div", {
        className: "slite-editor-table-cell-drag-line horizontal",
        onMouseEnter: this.onMouseEnterHorizontalDragLine,
        onMouseLeave: this.onMouseLeaveHorizontalDragLine,
        contentEditable: false
      }, React.createElement("div", {
        className: "drag-line-background"
      }))));
    }
  }]);

  return TableCell;
}(Component);

_defineProperty(TableCell, "propTypes", {
  editor: PropTypes.instanceOf(Editor),
  attributes: PropTypes.object,
  children: PropTypes.node,
  store: PropTypes.shape({
    getItem: PropTypes.func,
    updateItem: PropTypes.func,
    subscribeToItem: PropTypes.func,
    unsubscribeFromItem: PropTypes.func
  }),
  node: PropTypes.instanceOf(Block),
  parent: PropTypes.instanceOf(Block),
  isFocused: PropTypes.bool,
  isMobile: PropTypes.bool
});

export { TableCell as default };